import * as React from 'react';
import { useState, useContext} from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import { HuePicker } from 'react-color';
import {randomId, randomColor} from "../utils/functions";
import EditableRange from "../components/EditableRange";
import ColorPicker from "../components/ColorPicker";
import {Trash, X, Eye, Plus, WarningCircle, Info} from "@phosphor-icons/react";
import EditNow from "../components/EditNow";
import DataTable from 'react-data-table-component';
import Pagination			from "../components/Pagination";
import Select from "react-select";


const multiplierOptions = [
	{value:1, label:'1X'},
	{value:2, label:'2X'},
	{value:3, label:'3X'},
	{value:4, label:'4X'},
	{value:5, label:'5X'},
	{value:6, label:'6X'},
	{value:7, label:'7X'},
	{value:8, label:'8X'},
	{value:9, label:'9X'},
	{value:10, label:'10X'},
]

export default function DialogEditTurbines({
		onClose,
		onAdd, 
		tc,
		scenario
}) {
		
	const [status, setStatus]	= useState(false);

	var updateTimer = null;
	
	if(!tc || !tc.scenario){
		return
	}

	const init = () => {
	}
	
	const handleClose = () => {
		onClose();
	};

	const createCircle = () =>{
		
		const data = {
			name: 'Circle '+(tc.scenario.wtgSettings.circles.length+1),
			color: randomColor(),
			visible: true,
			radius:100
		}
		
		vindrApi.addCircle(tc.scenario.projectid, tc.scenario.scenario_id, data).then((res)=>{
			if(res && res.id){
				const s = structuredClone(tc.scenario);
				s.wtgSettings.circles.unshift(res);
				tc.setScenario(s);
				setStatus(Math.random());
				tc.draw.drawCircles(s);
			}
		});
	}
	const updateCircle = (id, data, remove) => {
		data = {...data, ...{id:id}};
		
		
		tc.draw.updateCircleColor(id, data.color);
	
		
	}
	const updateCircleAPI = (id, data, remove) => {
		data = {...data, ...{id:id}};

		vindrApi.updateCircle(tc.scenario.projectid, tc.scenario.scenario_id, data, remove).then((res)=>{
			if(res && res.id){
				updateScenarioCircle(data, remove);
			}
			updateTimer = null;
		});
	}

	const handleDelete = () => {
		tc.scenario.wtgSettings.circles = [];
		onAdd(tc.scenario);
		handleClose();
	}
	
	const updateScenarioCircle = (data, remove) => {
		
		const s = structuredClone(tc.scenario);
		const idx = s.wtgSettings.circles.findIndex((a)=>{return a.id == data.id})
		if(idx == -1)
			return;
		if(remove)
			s.wtgSettings.circles.splice(idx, 1);
		else
			s.wtgSettings.circles[idx] = {...s.wtgSettings.circles[idx], ...data};
		
		tc.setScenario(s);
		tc.draw.drawCircles(s);
		setStatus(Math.random());
	}

	const updateEllipse = (data) => {
		vindrApi.updateEllipse(tc.scenario.projectid, tc.scenario.scenario_id, data).then((res)=>{
			if(res && res.minorAxis){
				updateScenarioEllipse(res);
			}
		});	
	}
	const updateScenarioEllipse = (data) => {
		const s = structuredClone(tc.scenario);

		s.wtgSettings.windEllipse.custom = data;
		tc.setScenario(s);
		setStatus(Math.random());
		
		tc.infoLayers.current.resetSystemLayer("ellipses");
	}
	
	const validateRadius = (value) =>{
		return new RegExp('^\\d+$').test(value)
	}
	
	const validateDirection = (value) =>{
		const n = Number(value);
		return Number.isInteger(n) && n >= 0 && n <= 360;
	}
	
	
	const currEllipse = tc.draw.context.getters.scenario.wtgSettings.windEllipse.custom;
	const defEllipse = tc.draw.context.getters.scenario.wtgSettings.windEllipse.default;
	
	return (
		<Card className="turbines-dialog">
			<Card.Header>
				<h6 className="card-title">
					Style all turbines
					<span onClick={handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
				</h6>
						
			</Card.Header>
			<Card.Body>
				<Row className="mb-3">
					<Col><b>Circles</b></Col>
					<Col className="text-end"><Button onClick={createCircle} size="sm" className="btn-blue"><Plus size={16} />Add circle</Button></Col>
				</Row>
				
				<DataTable
					data={tc.draw.context.getters.scenario.wtgSettings.circles}
					className="circles"
					columns={
						[
							{
								id:'',
								selector: row => row.id,
								format: (a) =>	(<Eye weight="bold" className={!a.visible ? 'opacity-25' : ''} onClick={() => updateCircleAPI(a.id, {'visible': !a.visible})} size={16} />),
								width: "25px",
							},
							{
								id:'name',
								selector: row => row.name,
								format: (a) =>	(<EditNow placeholder={a.name} value={a.name} onUpdate={(name) => updateCircleAPI(a.id, {'name': name})} editable={true} />),
							},
							{
								id:'radius',
								selector: row => row.radius,
								format: (a) =>	(<EditNow placeholder={a.radius} onUpdate={(radius) => updateCircleAPI(a.id, {'radius': radius})}  validate={validateRadius} value={a.radius} editable={true} singleClick={true} suffix="m" />),
								right:true,
								width: "60px",
							},
							{
								id:'color',
								selector: row => row.color,
								format: (a) =>	(<ColorPicker hideHex={true} color={a.color} onChangeComplete={(color) => updateCircleAPI(a.id, {'color': color})} onChange={(color) => updateCircle(a.id, {'color': color})} />),
								width: "40px",
								right:true,

							},
							{
								id:'remove',
								selector: row => row.id,
								format: (a) =>	(<X onClick={() => updateCircleAPI(a.id, {}, true)} weight="bold" className="remove-icon" size={16} />),
								width: "25px",
								right:true,
							},
						]
					}
					noTableHead={true}
					noDataComponent={

						<Row className="p-0 py-3 pb-5 m-0 no-results">
							No circles added yet.  Click “+ Add circle” to create one.
						</Row>
					}
					customStyles={{
						cells:{
							style: {
								paddingLeft:'0',
								paddingRight:'0',
								minWidth:'0px !important',
							}
						},
					}}
					pagination
					paginationPerPage={3}
					paginationComponent = {Pagination}
					paginationComponentOptions = {{
						rowsPerPageText: 'Show',
						type: 'circles',
						hideRowsPerPage: true,
						rangeSeparatorText: 'of',
						selectAllRowsItemText: 'All',
					}}
				/>
			</Card.Body>
			<Card.Body className="ellipses">

				<Row className="mb-3">
					<Col>
						<b>Wind ellipse</b> 
						<div className="branded-tooltip">
							<Info weight="bold" size={16} />
							<div className="text">
								<span><Info weight="bold" size={16} /> Wind ellipse </span>

								The wind ellipse is based on the project's dominant wind direction and a 2x rotor diameter crosswind and 5x rotor diameter downwind. You can override these default values. 
							</div>
						</div>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col xs="1"></Col>
					<Col>Wind direction</Col>
					<Col xs="2" className="text-end"><EditNow key={Math.random()}  className={currEllipse.orientation != defEllipse.orientation ? 'outofbounds' : ''} placeholder={currEllipse.orientation} validate={validateDirection} onUpdate={(orientation) => updateEllipse({'orientation': orientation})}  value={currEllipse.orientation} editable={true} singleClick={true} suffix="º" /></Col>
				</Row>
				<Row className="mb-3">
					<Col xs="1"></Col>
					<Col>Crosswind</Col>
					<Col xs="3" className="text-end">
					
						<Form.Select size="sm" value={currEllipse.minorAxis} onChange={(e) => updateEllipse({'minorAxis': e.target.value})}  className={currEllipse.minorAxis != defEllipse.minorAxis ? 'outofbounds' : ''}>
							{
								multiplierOptions.map((o)=>{
									return (<option value={o.value}>{o.label}</option>)
								})
							}
						</Form.Select>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col xs="1"></Col>
					<Col>Downwind</Col>
					<Col xs="3" className="text-end">
						<Form.Select size="sm" value={currEllipse.majorAxis} onChange={(e) => updateEllipse({'majorAxis': e.target.value})} className={currEllipse.majorAxis != defEllipse.majorAxis ? 'outofbounds' : ''}>
							{
								multiplierOptions.map((o, k)=>{
									return (<option key={k} value={o.value}>{o.label}</option>)
								})
							}
						</Form.Select>
					</Col>
				</Row>
				{(currEllipse.minorAxis != defEllipse.minorAxis || currEllipse.majorAxis != defEllipse.majorAxis || currEllipse.orientation != defEllipse.orientation) &&
				<>
					<Row className="mb-3 outofbounds-text">
					
						<Col xs="1"><WarningCircle weight="bold" size={16} /></Col>
						<Col>
							The default wind ellipse setting have been modified. <a hreaf="#" onClick={(e) => updateEllipse({'orientation': defEllipse.orientation, majorAxis:defEllipse.majorAxis, minorAxis: defEllipse.minorAxis})}>Restore to defaults</a>
						</Col>
					</Row>
				</>
				}
				
				
			</Card.Body>
		</Card>
		
	);
}
